import { getStrategies } from './getStrategies';
/**
 * Deserializes the given payload into a new Stark instance.
 */
export function getDeserializedInstance(instance, payload) {
    const adapters = getStrategies(payload, instance);
    return Object.assign(Object.assign({}, instance), { adapters: Object.keys(adapters)
            .map((strategy) => strategy)
            .reduce((adapters, strategy) => {
            const newAdapter = adapters[strategy];
            const oldAdapter = instance.adapters[strategy];
            const serializableKeys = Object.keys(newAdapter.toJSON()).map((key) => key);
            return Object.assign(Object.assign({}, adapters), { [strategy]: Object.assign(newAdapter, 
                // assign the serialized adapter's original parameters
                serializableKeys.reduce((params, key) => (Object.assign(Object.assign({}, params), { [key]: oldAdapter[key] })), {}), 
                // override those with the initializationParams (if any)
                payload) });
        }, adapters) });
}
